import { useEffect, useMemo, useRef } from "react";

import { useFeatureViewsData } from "@/app/data/useFeatureViewsData";
import { useErrorToast } from "@/common/hooks/useErrorToast";
import { useFeatureViewParam } from "@/common/hooks/useFeatureViewParam";
import { getFlagViewDisplayName } from "@/feature/utils/flagView";

export function useSelectedFeatureView() {
  const errorToast = useErrorToast();
  const [viewId, setViewId] = useFeatureViewParam();
  const notifiedRef = useRef<string | undefined>();

  const { data: featureViews } = useFeatureViewsData();

  const view = useMemo(
    () =>
      featureViews?.find((v) => v.id === viewId) ??
      featureViews?.find((v) => v.type === "all"),
    [viewId, featureViews],
  );

  useEffect(() => {
    if (
      viewId &&
      view &&
      view.id !== viewId &&
      viewId !== notifiedRef.current
    ) {
      errorToast({
        title: `Could not find the view, using "${getFlagViewDisplayName(view)}".`,
      });

      notifiedRef.current = viewId;
      setViewId(view.id);
    } else if (view && view.id === viewId) {
      notifiedRef.current = undefined;
    }
  }, [viewId, view, errorToast, setViewId]);

  return [view, setViewId] as const;
}
